'use strict';

import axios from 'axios';
import {
  setHtmlScrollable,
  setHtmlUnscrollable
} from '@jspartials/general-utils';
import {
  classes,
  addClassToElement,
  removeClassToElement,
  hasClassElement
} from '@jspartials/class-list-utils';
import { startSpinner, stopSpinner } from '@jscomponents/spinner';

// Selectors
const selector = {
  productOptionsModal: '#productOptionsModal',
  steps: {
    modalBody: '.js-options-modal-body',
    currentStep: '[data-current-step]',
    optionId: '[data-option-id]',
    optionsStep: '.js-options-step',
    optionsStepsContainer: '.js-options-steps-container',
    modalClose: '.js-modal-close',
    prevStep: '.js-prev-step',
    optionsModalBody: '.js-options-modal-body',
    modalImages: '.js-modal-images',
    optionValueGoNext: '.js-option-value-go-next',
    modalColoredImages: '.js-modal-colored-images'
  },
  summary: {
    optionTerms: '#optionsTerms',
    optionValueContainer: '.js-option-value-container',
    summaryTermsError: '.js-option-summary-terms-error',
    buttonOptionsAddToCart: '.js-button-options-add-to-cart',
    checkboxOptionTerms: '.js-checkbox-option-terms',
    optionTitle: '.js-option-title',
    optionPrice: '.js-option-price',
    optionValueError: '.js-option-value-error',
    optionDescription: '.js-option-description',
    optionSummaryMessage: '.option-summary-message'
  },
  prescription: {
    optionValuePrescription: '.js-option-value-prescription-container',
    dipCheckbox: '.js-np-dip-checkbox',
    inputsToValidate: '.prescription-form input.validate',
    selectToValidate: '.prescription-form select.validate',
    dipNpCheckbox: '.dip-np',
    np: '.np',
    dip: '.dip',
    prescriptionTerms: '#prescriptionTerms',
    errorMessageInputs: '.error-message .input-error'
  }
};

const element = {
  productOptionsModal: null,
  steps: {
    modalBody: null,
    currentStep: null,
    optionId: null,
    optionsStep: null,
    optionsStepsContainer: null,
    modalClose: null,
    prevStep: null,
    optionsModalBody: null,
    modalImages: null,
    optionValueGoNext: null,
    modalColoredImages: null
  },
  summary: {
    optionTerms: null,
    optionValueContainer: null,
    summaryTermsError: null,
    buttonOptionsAddToCart: null,
    checkboxOptionTerms: null,
    optionTitle: null,
    optionPrice: null,
    optionValueError: null,
    optionDescription: null,
    optionSummaryMessage: null
  },
  prescription: {
    optionValuePrescription: null,
    dipCheckbox: null,
    inputsToValidate: null,
    selectToValidate: null,
    dipNpCheckbox: null,
    np: null,
    dip: null,
    prescriptionTerms: null,
    errorMessageInputs: null
  }
};

/**
 * Initializes the elements
 * @returns {void}
 */
const initElements = () => {
  element.productOptionsModal = document.querySelector(
    selector.productOptionsModal
  );
  element.steps.modalBody = document.querySelector(selector.steps.modalBody);
  element.steps.currentStep = document.querySelector(
    selector.steps.currentStep
  );
  element.steps.optionId = document.querySelector(selector.steps.optionId);
  element.steps.optionsStep = document.querySelectorAll(
    selector.steps.optionsStep
  );
  element.steps.optionsStepsContainer = document.querySelector(
    selector.steps.optionsStepsContainer
  );
  element.steps.modalClose = document.querySelector(selector.steps.modalClose);
  element.steps.prevStep = document.querySelector(selector.steps.prevStep);
  element.steps.optionsModalBody = document.querySelector(
    selector.steps.optionsModalBody
  );
  element.steps.modalImages = document.querySelector(
    selector.steps.modalImages
  );
  element.steps.optionValueGoNext = document.querySelectorAll(
    selector.steps.optionValueGoNext
  );
  element.steps.modalColoredImages = document.querySelector(
    selector.steps.modalColoredImages
  );
  element.summary.optionTerms = document.querySelector(
    selector.summary.optionTerms
  );
  element.summary.optionValueContainer = document.querySelectorAll(
    selector.summary.optionValueContainer
  );
  element.summary.summaryTermsError = document.querySelector(
    selector.summary.summaryTermsError
  );
  element.summary.buttonOptionsAddToCart = document.querySelector(
    selector.summary.buttonOptionsAddToCart
  );
  element.summary.checkboxOptionTerms = document.querySelector(
    selector.summary.checkboxOptionTerms
  );
  element.summary.optionTitle = document.querySelector(
    selector.summary.optionTitle
  );
  element.summary.optionPrice = document.querySelector(
    selector.summary.optionPrice
  );
  element.summary.optionValueError = document.querySelector(
    selector.summary.optionValueError
  );
  element.summary.optionDescription = document.querySelector(
    selector.summary.optionDescription
  );
  element.summary.optionSummaryMessage = document.querySelector(
    selector.summary.optionSummaryMessage
  );
  element.prescription.optionValuePrescription = document.querySelectorAll(
    selector.prescription.optionValuePrescription
  );
  element.prescription.dipCheckbox = document.querySelector(
    selector.prescription.dipCheckbox
  );
  element.prescription.dipNpCheckbox = document.querySelector(
    selector.prescription.dipNpCheckbox
  );
  element.prescription.np = document.querySelector(selector.prescription.np);
  element.prescription.dip = document.querySelector(selector.prescription.dip);
  element.prescription.inputsToValidate = document.querySelectorAll(
    selector.prescription.inputsToValidate
  );
  element.prescription.selectToValidate = document.querySelectorAll(
    selector.prescription.selectToValidate
  );
  element.prescription.prescriptionTerms = document.querySelector(
    selector.prescription.prescriptionTerms
  );
  element.prescription.errorMessageInputs = document.querySelectorAll(
    selector.prescription.errorMessageInputs
  );
};

function closeModal() {
  setHtmlScrollable();
  if (hasClassElement(element.productOptionsModal, classes.is.visible)) {
    removeClassToElement(element.productOptionsModal, classes.is.visible);
  }
  setTimeout(function () {
    if (element.steps.optionsModalBody) {
      element.steps.optionsModalBody.setAttribute(
        'data-current-step',
        'step' + 1
      );
    }
    element.productOptionsModal.style.display = 'none';
  }, 200);
}

function openModal() {
  setHtmlUnscrollable();
  element.productOptionsModal.style.display = 'block';
  setTimeout(function () {
    addClassToElement(element.productOptionsModal, classes.is.visible);
  }, 50);
}

function setSelected(data) {
  data.product.options.forEach(function (option) {
    var optionContainer = element.productOptionsModal.querySelector(
      '.js-options-step[data-option-id="' + option.id + '"]'
    );
    var summaryElement = element.productOptionsModal.querySelector(
      '.js-options-step[data-step-id="complete"] [data-option-id="' +
        option.id +
        '"]'
    );
    var selectedOptionContainer = optionContainer.querySelector(
      '.js-option-value-container.is-selected'
    );

    if (selectedOptionContainer) {
      removeClassToElement(selectedOptionContainer, classes.is.selected);
    }

    if (option.selectedValueId) {
      var optionElement = optionContainer.querySelector(
        '.js-option-value-container[data-value-id="' +
          option.selectedValueId +
          '"]'
      );

      var inputElement = summaryElement.parentElement.querySelector(
        '[name="' + option.id + '"]'
      );
      inputElement.value = option.selectedValueId;

      if (
        optionElement &&
        optionElement.getAttribute('data-hidden') !== 'true'
      ) {
        addClassToElement(optionElement, classes.is.selected);
        removeClassToElement(summaryElement, classes.is.filtered);

        var summaryElementOptionTitle = summaryElement.querySelector(
          selector.summary.optionTitle
        );

        var optionElementdataValueName =
          optionElement.getAttribute('data-value-name');
        summaryElementOptionTitle.textContent = optionElementdataValueName;

        var summaryElementOptionPrice = summaryElement.querySelector(
          selector.summary.optionPrice
        );

        var optionElementPrice = optionElement.querySelector(
          selector.summary.optionPrice
        ).textContent;

        summaryElementOptionPrice.textContent = optionElementPrice;

        var summaryElementOptionDescription = summaryElement.querySelector(
          selector.summary.optionDescription
        );

        var optionElementDescription = optionElement.querySelector(
          selector.summary.optionTitle
        ).textContent;
        summaryElementOptionDescription.textContent = optionElementDescription;
      } else {
        addClassToElement(summaryElement, classes.is.filtered);
      }
    }

    if (option.selectedValueId === 'EMPTY') {
      var optionGoNextElement = optionContainer.querySelector(
        selector.steps.optionValueGoNext
      );
      if (hasClassElement(optionGoNextElement, classes.is.enabled)) {
        removeClassToElement(optionGoNextElement, classes.is.enabled);
      }
    }
  });
}

function determineException(selectedElement) {
  var currentOptionId = selectedElement
    .closest(selector.steps.optionId)
    .getAttribute('data-option-id');
  var currentOptionValue = selectedElement.getAttribute('data-value-id');

  var selectedValueUrl = selectedElement.getAttribute('value');

  if (window.optionModalConfig.activeException) {
    if (window.optionModalConfig.activeException === currentOptionId) {
      window.optionModalConfig.activeException = null;
      window.optionModalConfig.prescriptionStep = false;
      window.optionModalConfig.skipSteps = [];
      window.optionModalConfig.nextStep = selectedElement
        .closest('[data-step-id]')
        .getAttribute('data-step-id');
      window.optionModalConfig.prevStep = selectedElement
        .closest('[data-step-id]')
        .getAttribute('data-step-id');

      removeClassToElement(
        element.productOptionsModal.querySelector(
          '.js-option-value-container.is-filtered',
          classes.is.filtered
        )
      );

      element.productOptionsModal
        .querySelector(selector.summary.buttonOptionsAddToCart)
        .removeAttribute('data-prescription-step');

      element.productOptionsModal
        .querySelectorAll(selector.summary.optionValueContainer)
        .forEach(function (element) {
          element.removeAttribute('data-autoset-option');
          element.removeAttribute('data-autoset-value');
        });
    }
  }

  if (currentOptionId) {
    window.optionModalConfig.every(function (exception) {
      if (
        currentOptionId === exception.exceptionId &&
        currentOptionValue === exception.exceptionValue
      ) {
        window.optionModalConfig.activeExceptionId = exception.id;
        window.optionModalConfig.activeException = exception.exceptionId;

        if (exception.rules.hasOwnProperty('autoSet')) {
          selectedValueUrl =
            optionsActionUrl +
            '&dwopt_' +
            productId +
            '_' +
            currentOptionId +
            '=' +
            currentOptionValue;
          const autoSetKeys = Object.keys(exception.rules.autoSet);
          autoSetKeys.forEach(function (key) {
            var optionId = key;
            var optionVal = exception.rules.autoSet[key];
            window.optionModalConfig.skipSteps.push(optionId);
            selectedValueUrl +=
              '&dwopt_' + productId + '_' + optionId + '=' + optionVal;
          });
        }

        if (exception.rules.hasOwnProperty('filter')) {
          const filterKeys = Object.keys(exception.rules.filter);
          filterKeys.forEach(function (key) {
            var optionId = key;
            var optionValArray = exception.rules.filter[key];
            var optionsContainer = document.querySelector(
              '.js-options-step[data-option-id="' + optionId + '"]'
            );

            optionsContainer
              .querySelectorAll(selector.summary.optionValueContainer)
              .forEach(function (optionValueContainer) {
                addClassToElement(optionValueContainer, classes.is.filtered);
              });

            optionValArray.forEach(function (idToShow) {
              var optionValueContainer = optionsContainer.querySelector(
                '.js-option-value-container[data-value-id="' + idToShow + '"]'
              );
              removeClassToElement(optionValueContainer, classes.is.filtered);
            });

            if (window.optionModalConfig.skipSteps.indexOf(optionId) > -1) {
              window.optionModalConfig.skipSteps =
                window.optionModalConfig.skipSteps.filter(function (value) {
                  return value != optionId;
                });
            }
          });
        }

        if (exception.rules.hasOwnProperty('autoSetNextSteps')) {
          exception.rules.autoSetNextSteps.forEach(function (value) {
            var optionId = value.optionId;
            var optionVal = value.optionValue;
            var autoSetRule = value.autoSet;

            var optionsContainer = document.querySelector(
              '.js-options-step[data-option-id="' + optionId + '"]'
            );
            var optionElement = optionsContainer.querySelector(
              '[data-value-id="' + optionVal + '"]'
            );

            const autoSetRuleKeys = Object.keys(autoSetRule);
            autoSetRuleKeys.forEach(function (key) {
              var autoSetOptionId = key;
              var autoSetOptionValue = autoSetRule[key];
              optionElement.dataset.autosetOption = autoSetOptionId;
              optionElement.dataset.autosetValue = autoSetOptionValue;
            });
          });
        }

        if (exception.rules.hasOwnProperty('summaryMessage')) {
          var optionSummaryMessage = element.productOptionsModal.querySelector(
            selector.summary.optionSummaryMessage
          );
          optionSummaryMessage.textContent = decodeURIComponent(
            exception.rules.summaryMessage
          )
            .replace(/&quot;/g, '"')
            .replace(/&#039;/g, "'");
        } else {
          element.productOptionsModal.querySelector(
            selector.summary.optionSummaryMessage
          ).innerHTML = '';
        }

        if (exception.rules.hasOwnProperty('prescriptionStep')) {
          window.optionModalConfig.prescriptionStep = true;
          element.productOptionsModal.querySelector(
            selector.summary.buttonOptionsAddToCart
          ).dataset.prescriptionStep = true;
        }

        return false;
      }

      return true;
    });
  }

  if (
    selectedElement.dataset.autosetOption &&
    selectedElement.dataset.autosetValue
  ) {
    var mainValueUrl = selectedValueUrl.split('?');
    var queryString;
    if (mainValueUrl.length > 1) {
      queryString = mainValueUrl[1].split('&');
      queryString = queryString.map(function (value) {
        if (value.indexOf(selectedElement.dataset.autosetOption) > -1) {
          value =
            'dwopt_' +
            productId +
            '_' +
            selectedElement.dataset.autosetOption +
            '=' +
            selectedElement.dataset.autosetValue;
        }
        return value;
      });

      queryString = queryString.join('&');
      mainValueUrl[1] = queryString;
      selectedValueUrl = mainValueUrl.join('?');
    }
  }

  return selectedValueUrl;
}
function setNavStep(flag, step) {
  var currentStep;

  if (!step) {
    step =
      flag === 'next'
        ? window.optionModalConfig.nextStep
        : window.optionModalConfig.prevStep;
  }

  if (typeof step === 'string' && step.includes('step')) {
    step = step.replace('step', '');
  }

  currentStep = step;

  if (
    step === 'complete' ||
    step == 'prescription' ||
    step == 'prescription-form'
  ) {
    step =
      element.productOptionsModal.querySelectorAll(selector.steps.optionsStep)
        .length - 2;
  }

  if (flag === 'next') {
    step = Number(step) + 1;
  } else {
    step = Number(step) - 1;
  }

  if (step <= 1) {
    step = 1;
  }

  if (
    step >=
    element.productOptionsModal.querySelectorAll(selector.steps.optionsStep)
      .length -
      2
  ) {
    step = 'complete';
  }

  if (
    (currentStep === 'complete' &&
      window.optionModalConfig.prescriptionStep &&
      flag === 'next') ||
    (currentStep === 'prescription-form' &&
      window.optionModalConfig.prescriptionStep &&
      flag === 'prev')
  ) {
    step = 'prescription';
  }

  if (
    currentStep === 'prescription' &&
    window.optionModalConfig.prescriptionStep &&
    flag === 'next'
  ) {
    step = 'prescription-form';
  }

  if (window.optionModalConfig.skipSteps.length > 0) {
    if (
      step === 'complete' ||
      step === 'prescription' ||
      step === 'prescription-form'
    ) {
      var stepOptionId = document
        .querySelector('.js-options-step[data-step-id="' + step + '"]')
        .getAttribute('data-option-id');
    } else {
      var stepOptionId = document
        .querySelector('.js-options-step[data-step-id="step' + step + '"]')
        .getAttribute('data-option-id');
    }
    if (window.optionModalConfig.skipSteps.indexOf(stepOptionId) > -1) {
      if (step > 1) {
        setNavStep(flag, step);
        return;
      }
    }
  }

  window.optionModalConfig.nextStep = step;
  window.optionModalConfig.prevStep = step;
}

function goToPrevStep() {
  setNavStep('prev');
  if (
    window.optionModalConfig.prevStep === 'complete' ||
    window.optionModalConfig.prevStep === 'prescription' ||
    window.optionModalConfig.prevStep === 'prescription-form'
  ) {
    element.steps.optionsModalBody.setAttribute(
      'data-current-step',
      window.optionModalConfig.prevStep
    );
  } else {
    element.steps.optionsModalBody.setAttribute(
      'data-current-step',
      'step' + window.optionModalConfig.prevStep
    );
  }
  setContainerSize();
}

function goToNextStep() {
  setNavStep('next');
  if (
    window.optionModalConfig.nextStep === 'complete' ||
    window.optionModalConfig.nextStep === 'prescription' ||
    window.optionModalConfig.nextStep === 'prescription-form'
  ) {
    element.steps.optionsModalBody.setAttribute(
      'data-current-step',
      window.optionModalConfig.nextStep
    );
  } else {
    element.steps.optionsModalBody.setAttribute(
      'data-current-step',
      'step' + window.optionModalConfig.nextStep
    );
  }
  setContainerSize();
}

function selectOption(selectedElement) {
  var selectedValueUrl = determineException(selectedElement);

  var productContainer = selectedElement.closest('.set-item');
  if (!productContainer) {
    productContainer = selectedElement.closest('.product-detail');
  }

  var eventBeforeAttributeSelect = new CustomEvent(
    'product:beforeAttributeSelect',
    {
      detail: {
        url: selectedValueUrl,
        container: productContainer
      }
    }
  );

  document.body.dispatchEvent(eventBeforeAttributeSelect);

  axios
    .get(selectedValueUrl)
    .then((response) => {
      setSelected(response.data);
      var eventAfterAttributeSelect = new CustomEvent(
        'product:afterAttributeSelect',
        {
          detail: {
            data: response.data,
            container: productContainer
          }
        }
      );

      document.body.dispatchEvent(eventAfterAttributeSelect);
      goToNextStep();
    })
    .catch((error) => {
      console.log(error);
    })
    .then(() => {
      stopSpinner();
    });
}

function selectColorImage(selectedElement) {
  var selectedColor = selectedElement
    .getAttribute('data-value-id')
    .toLowerCase();

  if (element.steps.modalColoredImages.children.length) {
    var coloredImageElements =
      element.steps.modalColoredImages.querySelectorAll(
        '[data-image-url*="' + selectedColor + '"]'
      );
    element.steps.modalColoredImages
      .querySelectorAll('.is-active')
      .forEach(function (element) {
        element.classList.remove('is-active');
      });
    if (coloredImageElements.length) {
      coloredImageElements.forEach(function (element) {
        element.classList.add('is-active');
      });
    }
  }
}

function validatePrescriptionForm() {
  var formValid = true;
  var npValid = true;

  element.prescription.errorMessageInputs.forEach(function (element) {
    element.style.display = 'none';
  });

  element.prescription.inputsToValidate.forEach(function (input) {
    if (hasClassElement(input.parentElement, classes.is.active)) {
      var inputValue = input.value;
      if (inputValue === '') {
        formValid = false;
      } else {
        inputValue = Number(inputValue);
        if (typeof prescriptionModalJson !== 'undefined') {
          if (hasClassElement(input, 'np-input')) {
            if (
              inputValue < Number(prescriptionModalJson.np.min) ||
              inputValue > Number(prescriptionModalJson.np.max)
            ) {
              element.productOptionsModal.querySelector(
                '.prescription-form .js-error-message .np-input-error'
              ).style.display = 'inline';
              formValid = false;
              npValid = false;
            } else {
              if (npValid) {
                element.productOptionsModal.querySelector(
                  '.prescription-form .js-error-message .np-input-error'
                ).style.display = 'none';
                formValid = true;
              }
            }
          } else if (hasClassElement(input, 'dip-input')) {
            if (
              inputValue < Number(prescriptionModalJson.np.min * 2) ||
              inputValue > Number(prescriptionModalJson.np.max * 2)
            ) {
              element.productOptionsModal.querySelector(
                '.prescription-form .js-error-message .dip-input-error'
              ).style.display = 'inline';
              formValid = false;
            } else {
              element.productOptionsModal.querySelector(
                '.prescription-form .js-error-message .dip-input-error'
              ).style.display = 'none';
              formValid = true;
            }
          }
        }
      }
    }
  });

  if (formValid) {
    element.prescription.selectToValidate.forEach(function (select) {
      var selectValue = select.value;
      var valueType = select.getAttribute('data-type');

      if (selectValue === null || selectValue === '') {
        formValid = false;
      } else {
        selectValue = Number(selectValue);
        if (typeof prescriptionModalJson !== 'undefined') {
          var minVal = Number(prescriptionModalJson[valueType][0]);
          var maxVal = Number(
            prescriptionModalJson[valueType][
              prescriptionModalJson[valueType].length - 1
            ]
          );
          if (selectValue < minVal || selectValue > maxVal) {
            formValid = false;
          }
        }
      }
    });
  }

  if (formValid && element.prescription.prescriptionTerms !== null) {
    if (!element.prescription.prescriptionTerms.checked) {
      formValid = false;
    }
  }

  return formValid;
}

function setGeneralListeners() {
  element.steps.modalClose.addEventListener('click', function (e) {
    e.preventDefault();
    closeModal();
  });

  element.steps.prevStep.addEventListener('click', function (e) {
    e.preventDefault();
    goToPrevStep();
  });

  //recorremos todos los elementos de la opción para añadirles el evento click
  element.summary.optionValueContainer.forEach(function (optionValueContainer) {
    optionValueContainer.addEventListener('click', function () {
      var selectedElement = this;

      //revisar
      element.summary.optionValueContainer.forEach(function (siblings) {
        removeClassToElement(siblings, classes.is.selected);
      });

      addClassToElement(selectedElement, classes.is.selected);

      var parentOptionId = selectedElement
        .closest(selector.steps.optionId)
        .getAttribute('data-option-id');

      var parentOption = selectedElement.closest(selector.steps.optionId);
      var nextOption = null;

      if (parentOptionId !== 'hk_lens_color') {
        nextOption = parentOption.querySelector(
          selector.steps.optionValueGoNext
        );

        if (nextOption) {
          nextOption.dispatchEvent(new Event('click'));
        }
      } else {
        var errorElement = parentOption.querySelector(
          selector.summary.optionValueError
        );
        removeClassToElement(errorElement, classes.is.visible);
        nextOption = parentOption.querySelector(
          selector.steps.optionValueGoNext
        );
        removeClassToElement(nextOption, classes.has.error);
        addClassToElement(nextOption, classes.is.enabled);

        selectColorImage(selectedElement);
      }
    });
  });

  element.steps.optionValueGoNext.forEach(function (optionValueGoNext) {
    optionValueGoNext.addEventListener('click', function (e) {
      e.preventDefault();

      var selectedElementExist;
      var selectedElement;
      var currentStep =
        element.steps.optionsModalBody.getAttribute('data-current-step');

      var currentDataStep = document.querySelectorAll(
        `[data-step-id="${currentStep}"]`
      );

      currentDataStep.forEach(function (step) {
        selectedElementExist = step.querySelector('.is-selected');
      });

      if (selectedElementExist) {
        selectedElement = selectedElementExist;
      }

      if (selectedElement) {
        selectOption(selectedElement);
      } else {
        addClassToElement(e.target, classes.has.error);
        addClassToElement(e.target.nextElementSibling, classes.is.visible);
      }
    });
  });

  element.prescription.optionValuePrescription.forEach(function (
    optionValuePrescription
  ) {
    optionValuePrescription.addEventListener('click', function (e) {
      e.preventDefault();
      var selectedElement = this;

      switch (selectedElement.getAttribute('data-option-id')) {
        case 'prescription_now':
          goToNextStep();
          break;
        case 'prescription_later':
          window.location.href =
            selectedElement.getAttribute('data-option-href');
          break;
        case 'prescription_appointment':
          window.location.href =
            selectedElement.getAttribute('data-option-href');
          break;
        default:
          break;
      }
    });
  });

  element.summary.optionTerms.addEventListener('change', function (e) {
    var target = this;
    if (target.matches(selector.summary.optionTerms)) {
      e.preventDefault();
      if (target.checked) {
        target
          .closest(selector.summary.checkboxOptionTerms)
          .querySelector(selector.summary.summaryTermsError).style.display =
          'none';
        element.summary.buttonOptionsAddToCart.disabled = false;
      } else {
        target
          .closest(selector.summary.checkboxOptionTerms)
          .querySelector(selector.summary.summaryTermsError).style.display =
          'block';
        element.summary.buttonOptionsAddToCart.disabled = true;
      }
    }
  });

  document.body.addEventListener('product:afterAttributeSelect', function (e) {
    var response = e.detail;

    updatePrices(response.data);
    updateOptionsValues(response.data);

    var addToCartButton =
      element.productOptionsModal.querySelector('.add-to-cart');
    var product = response.data.product;
    var productContainer = response.data.container;

    var updateAddToCartEvent = new CustomEvent('product:updateAddToCart', {
      detail: {
        product: product,
        productContainer: productContainer
      }
    });

    var statusUpdateEvent = new CustomEvent('product:statusUpdate', {
      detail: product
    });

    addToCartButton.dispatchEvent(updateAddToCartEvent);
    addToCartButton.dispatchEvent(statusUpdateEvent);
  });

  document.body.addEventListener('click', function (e) {
    var target = e.target;
    if (target && target.matches('#productOptionsModal .cart-and-ipay')) {
      if (!element.optionTerms.checked) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var changeEvent = new Event('change');
        element.optionTerms.dispatchEvent(changeEvent);

        var completeStepScrollable = document.querySelector(
          '[data-step-id="complete"] .is-scrollable'
        );
        var optionSummaryTermsOffsetTop = element.optionTerms.offsetTop;
        var scrollAnimation = {
          scrollTop: optionSummaryTermsOffsetTop
        };

        completeStepScrollable.animate(scrollAnimation, {
          duration: 1000
        });
      }
    }
  });

  element.prescription.dipCheckbox.addEventListener('change', function (e) {
    var isChecked = e.target.checked;
    if (isChecked) {
      this.parentElement
        .querySelectorAll(selector.prescription.np)
        .forEach(function (np) {
          removeClassToElement(np, classes.is.active);
        });
      this.parentElement
        .querySelectorAll(selector.prescription.dip)
        .forEach(function (dip) {
          addClassToElement(dip, classes.is.active);
        });
    } else {
      this.parentElement
        .querySelectorAll(selector.prescription.np)
        .forEach(function (np) {
          addClassToElement(np, classes.is.active);
        });
      this.parentElement
        .querySelectorAll(selector.prescription.dip)
        .forEach(function (dip) {
          removeClassToElement(dip, classes.is.active);
        });
    }
  });

  document.body.addEventListener('change', function (e) {
    var target = e.target;
    var isCheckbox = target.matches(
      '#productOptionsModal .np-dip-checkbox input[type="checkbox"]'
    );
    var isInput = target.matches(
      '#productOptionsModal .prescription-form input.validate'
    );
    var isSelect = target.matches(
      '#productOptionsModal .prescription-form select.validate'
    );
    var isTermsCheckbox = target.matches(
      '#productOptionsModal .prescription-form #prescriptionTerms'
    );

    if (isCheckbox || isInput || isSelect || isTermsCheckbox) {
      var formValid = validatePrescriptionForm();
      var goNextButton = element.productOptionsModal.querySelector(
        '.prescription-form .js-prescription-go-next'
      );

      if (formValid) {
        goNextButton.disabled = false;
      } else {
        goNextButton.disabled = true;
      }
    }
  });

  document.body.addEventListener('submit', function (e) {
    e.preventDefault();
    var formValid = validatePrescriptionForm();
    const formData = new FormData();
    if (formValid) {
      addClassToElement(this, 'loading');
      var dnpValid =
        Number(
          element.productOptionsModal.querySelector(
            '.prescription-form input[name="np-left"]'
          ).value
        ) > 0 &&
        Number(
          element.productOptionsModal.querySelector(
            '.prescription-form input[name="np-right"]'
          ).value
        ) > 0;
      var formDataObject = {
        sku: productId,
        pliUUID: element.productOptionsModal.querySelector(
          '.prescription-form input[name="pliUUID"]'
        ).value,
        dip: element.productOptionsModal.querySelector(
          '.prescription-form .np.is-active'
        )
          ? Math.round(
              Number(
                element.productOptionsModal.querySelector(
                  '.prescription-form input[name="np-left"]'
                ).value
              ) +
                Number(
                  element.productOptionsModal.querySelector(
                    '.prescription-form input[name="np-right"]'
                  ).value
                )
            )
          : Math.round(
              element.productOptionsModal.querySelector(
                '.prescription-form input[name="dip"]'
              ).value
            ),
        sphere_left: element.productOptionsModal.querySelector(
          '.prescription-form select[name="sphere-left"]'
        ).value,
        sphere_right: element.productOptionsModal.querySelector(
          '.prescription-form select[name="sphere-right"]'
        ).value,
        cylinder_left: element.productOptionsModal.querySelector(
          '.prescription-form select[name="cylinder-left"]'
        ).value,
        cylinder_right: element.productOptionsModal.querySelector(
          '.prescription-form select[name="cylinder-right"]'
        ).value,
        axis_left: element.productOptionsModal.querySelector(
          '.prescription-form select[name="axis-left"]'
        ).value,
        axis_right: element.productOptionsModal.querySelector(
          '.prescription-form select[name="axis-right"]'
        ).value,
        dnp_left: dnpValid
          ? Number(
              element.productOptionsModal.querySelector(
                '.prescription-form input[name="np-left"]'
              ).value
            )
          : 0,
        dnp_right: dnpValid
          ? Number(
              element.productOptionsModal.querySelector(
                '.prescription-form input[name="np-right"]'
              ).value
            )
          : 0
      };

      formData.append('formDataObject', JSON.stringify(formDataObject));

      axios
        .post(validationEndpoint, formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        .then(function (response) {
          if (response.status === 200) {
            var data = response.data;
            if (!data.error) {
              startSpinner();
              location.href = document
                .querySelector('.add-to-cart')
                .getAttribute('data-cart');
            } else {
              element.productOptionsModal.querySelector(
                '.prescription-form .js-prescription-error'
              ).style.display = 'block';
              setContainerSize();

              document
                .querySelector(
                  '[data-step-id="prescription-form"] .is-scrollable'
                )
                .animate(
                  {
                    scrollTop: element.productOptionsModal.querySelector(
                      '.prescription-form .js-prescription-error'
                    ).offsetTop
                  },
                  1000
                );
            }
          } else {
            handleError();
          }
        })
        .catch(function (error) {
          handleError();
        });

      function handleError() {
        element.productOptionsModal.querySelector(
          '.prescription-form .js-prescription-error'
        ).style.display = 'block';
        setContainerSize();

        document
          .querySelector('[data-step-id="prescription-form"] .is-scrollable')
          .animate(
            {
              scrollTop: element.productOptionsModal.querySelector(
                '.prescription-form .js-prescription-error'
              ).offsetTop
            },
            1000
          );
      }
    }
  });

  document.body.addEventListener('product:afterAddToCart', function (e) {
    var data = e.detail.data;
    if (typeof data.pliUUID !== 'undefined') {
      element.productOptionsModal.querySelector(
        '.prescription-form input[name="pliUUID"]'
      ).value = data.pliUUID;
    }
    if (window.optionModalConfig.prescriptionStep) {
      stopSpinner();
      goToNextStep();
    }
  });

  window.addEventListener('resize', function () {
    setContainerSize();
  });
}

function updateOptionsValues(response) {
  response.product.options.forEach(function (option) {
    var optionsContainer = element.productOptionsModal.querySelector(
      '.js-options-step[data-option-id="' + option.id + '"]'
    );
    option.values.forEach(function (optionVal) {
      var optionValEl = optionsContainer.querySelector(
        '.js-option-value-container[data-value-id="' + optionVal.id + '"]'
      );
      optionValEl ? optionValEl.setAttribute('value', optionVal.url) : '';
    });
  });
}

function updatePrices(response) {
  element.productOptionsModal.querySelector(
    '.js-option-summary-price-sum'
  ).innerHTML = '';

  var decodedPrice = window.atob(response.product.price.htmlEncoded);
  element.productOptionsModal.querySelector(
    '.js-option-summary-price-sum'
  ).innerHTML = decodedPrice;

  if (
    response.product.price.sales &&
    response.product.price.sales.value &&
    String(response.product.price.sales.value) != 'null'
  ) {
    var addToCart = element.productOptionsModal.querySelector('.add-to-cart');
    var priceElement = addToCart.querySelector('.price');

    if (priceElement) {
      priceElement.outerHTML = response.product.price.html;
    } else {
      addToCart.insertAdjacentHTML('beforeend', response.product.price.html);
    }
  } else {
    var priceElement = element.productOptionsModal.querySelector(
      '.add-to-cart .price'
    );

    if (priceElement) {
      priceElement.remove();
    }
  }
}

function setContainerSize() {
  var maximumHeight = element.steps.optionsStepsContainer.offsetHeight;

  element.steps.optionsStep.forEach(function (step) {
    var valuesContainer = step.querySelector('.option-values');
    var availableSpace = 0;
    var neededHeight = 0;

    removeClassToElement(valuesContainer, classes.is.scrollable);
    valuesContainer.style.removeProperty('height');
    availableSpace = Math.round(
      maximumHeight - step.querySelector('h4').offsetHeight
    );
    neededHeight = Math.round(valuesContainer.offsetHeight);

    valuesContainer.style.height = availableSpace + 'px';
    if (neededHeight > availableSpace) {
      addClassToElement(valuesContainer, classes.is.scrollable);
    }
  });
}

function init() {
  window.prescriptionModalJson = JSON.parse(prescriptionModalJson);
  window.optionModalConfig = JSON.parse(optionsModalJson);
  window.optionModalConfig.nextStep = 1;
  window.optionModalConfig.prevStep = 1;
  window.optionModalConfig.activeExceptionId = null;
  window.optionModalConfig.activeException = null;
  window.optionModalConfig.skipSteps = [];
  window.optionModalConfig.prescriptionStep = false;

  //setGeneralListeners();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const showProductOptionsModalUrlParameter = urlParams.get(
    'showProductOptionsModal'
  );

  if (showProductOptionsModalUrlParameter === 'true') {
    openModal();
    setContainerSize();
  }
}

document.body.addEventListener('product:selectOptionsModal', function (e) {
  initElements();
  setGeneralListeners();
  openModal();
  setContainerSize();
});

document.addEventListener('DOMContentLoaded', function () {
  const modalEyewear = document.querySelector('#productOptionsModal');
  //si existe elemento modal en la página se inicializa
  if (modalEyewear !== null) {
    init();
  }
});
